(() => {
  const comparisons = document.querySelectorAll('[data-inside-comparison]');

  comparisons.forEach((comparison) => {
    const button = comparison.querySelector('[data-inside-comparison-toggle]');
    const stage = comparison.querySelector('[data-inside-comparison-stage]');
    const behind = comparison.querySelector('.yi2c-inside-comparison__image--behind');
    const after = comparison.querySelector('.yi2c-inside-comparison__image--after');

    if (!button || !stage || !behind || !after) return;

    const setState = (showAfter) => {
      comparison.classList.toggle('is-after', showAfter);
      button.setAttribute('aria-pressed', String(showAfter));
      button.textContent = showAfter ? 'See behind the photograph' : 'See what customers saw';
      stage.setAttribute(
        'aria-label',
        showAfter
          ? 'What customers saw. Use the button to see behind the photograph.'
          : 'Behind the photograph. Hover or focus to see what customers saw.'
      );
      behind.setAttribute('aria-hidden', String(showAfter));
      after.setAttribute('aria-hidden', String(!showAfter));
    };

    button.addEventListener('click', () => {
      setState(button.getAttribute('aria-pressed') !== 'true');
    });

    stage.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && comparison.classList.contains('is-after')) {
        setState(false);
        button.focus();
      }
    });
  });
})();
